<template>
    <div class="flow-blue-bg-color">
        <div class="flow-blue w3-sidebar w3-large" id="sidebar">
            <div class="w3-container w3-center w3-collapse" id="flow-side-menu-bar">
                <div class="w3-bar-block">
                    <router-link v-for="item in menuItems" v-if="showStatusOverviewMenu === true ? item.dh : !item.hideInNonDh"
                                 class="w3-button w3-bar-item menu-item"
                                 :key="item.name"
                                 :class="item.cls"
                                 :title="item.name" :to="item.type ? '/problem?reason=unlicensed' : {name: item.route}">

                        <div class="menu-icon">
                            <i class="fa" :class="item.icon"></i>
                        </div>
                        <div class="menu-name" v-bind:style="toggleMenuC">{{ item.name }}</div>
                    </router-link>
                </div>
            </div>
        </div>

        <header class="flow-blue-bg-color" id="flow-header">
            <div class="w3-container zero">
                <div class="w3-col w-30pc zero">
                    <h4 class="zero">
                        <i class="fa fa-bars w3-margin-left cursor-pointer" id="open-nav" @click="toggleMenu"
                        :title="expandMenu ? $t('collapseMenu') : $t('expandMenu')"></i>
                        <span class="font-weight-bold" id="company-name">Partheas Flow </span>
                    </h4>
                </div>
                <div class="w3-col w3-third w3-right">
                    <h4 v-if="currentUser" class="w3-right w3-margin-right zero" id="current-user">
                            <span class="current-ward cursor-pointer flow-margin-right w3-ripple"
                                  v-if="currentUser.wards.length > 1"
                                  @click="showWardList = !showWardList">
                                <span class="chosen-ward" v-model="selectedWard">
                                    {{ selectedWard }}
                                </span>
                                <i class="fa fa-chevron-down i-rotate" v-bind:class="showWardList ? 'active' : ''"></i>
                                <ul class="w3-ul flow-list w3-animate-opacity" v-if="showWardList">
                                    <li class="w3-ripple" v-for="ward in currentUser.wards" @click="chooseItem(ward)" v-if="selectedWard !== ward.displayName">{{ward.displayName}}</li>
                                </ul>
                            </span>
                            <span v-else class="current-ward">
                                <span class="chosen-ward" v-model="selectedWard">{{ selectedWard }}</span>
                            </span>

                            <span class="flow-margin-left flow-margin-right">|</span>

                        <i class="fa fa-user-circle flow-margin-right"
                           v-bind:class="currentUser.role ? currentUser.role.toLowerCase() + '-user-color' : ''">
                        </i>
                        <router-link :to="{name: 'account_setup'}">
                            <span id="current-user-name" class="font-weight-bold">{{ currentUser.name }}</span>
                        </router-link>
                    </h4>
                </div>
            </div>
        </header>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {EventBus} from "../../main";

    export default {
        name: "SideMenu",
        data: function () {
            return {
							expandMenu: false,
							selectedWard: '',
							showStatusOverviewMenu: false,
							showWardList: false,
							currentUser: {
								name: '',
								role: '',
								wards:[]
							},
							normalMenuItems: [
								{
									name: this.$t("dashboard"), icon: "fa-home", route: "dashboard", dh: true
								},
								{
									name: this.$t("searchAddNewPatient"), icon: "fa-search-plus", route: "search_add_new_patient", dh: true
								},
								{
									name: this.$t("consultations"), icon: "fa-calendar-alt", route: "consultation", dh: true
								},
								{
									name: this.$t("rooms"), icon: "fa-door-open", route: "rooms", dh: true
								},
							],
							powerMenuItems: [
								{
									name: this.$t("patients"), icon: "fa-users", route: "patients", cls: "flow-border-top", dh: true
								},
								{
									name: this.$t("physicians"), icon: "fa-user-md", route: "physicians", dh: true
								},
								{
								  name: this.$t("statusOverview"), icon: "fa-eye", route: "status_overview", dh: true, hideInNonDh: true
								}
							],
							adminMenuItems: [
								{
									name: this.$t("users"), icon: "fa-users-cog", route: "users", cls: "flow-border-top", dh: true
								},
								{
									name: this.$t("dataAnalytics"), icon: "fa-chart-line", route: "data_analytics", dh: true
								},
								{
									name: this.$t("functionalConfiguration"), icon: "fa-cogs", type: "demo", dh: true
								},
								{
									name: this.$t("wayFinding"), icon: "fa-arrows-alt", type: "demo", dh: true
								},
								{
									name: this.$t("smsServices"), icon: "fa-comment", type: "demo", dh: true
								}
							],
							accessControlItems: [
								{
									name:this.$t("access"),icon:"fa-universal-access", route:"access_control",cls: "flow-border-top", dh:true
								},
							],
							logoutMenuItem: [
								{
									name: this.$t("logout"), icon: "fa-sign-out-alt", route: "logout", dh: true
								}
							]
            };
        },
        methods: {
            toggleMenu: function () {
                this.expandMenu = !this.expandMenu;

                if (this.expandMenu) {
                    document.getElementById("sidebar").style.width = '20%';
                    document.getElementById("flow-content").style.marginLeft = '21%';

                } else {
                    document.getElementById("sidebar").style.width = '4%';
                    document.getElementById("flow-content").style.marginLeft = '5%';
                }

                EventBus.$emit("menuToggled");
            },
            chooseItem: function(chosenItem) {
                this.selectedWard = chosenItem.displayName;
								Vue.prototype.$showStatusOverviewMenu = chosenItem.uisettings.plugin === 'dh' || chosenItem.uisettings.plugin === 'mi';
                this.showStatusOverviewMenu = Vue.prototype.$showStatusOverviewMenu;
                EventBus.$emit("wardUpdated", chosenItem);
                this.$router.push('/dashboard');

            },
        },
        computed: {
            toggleMenuC: function () {
                return {
                    display: this.expandMenu ? "inline-block" : "none"
                }
            },
            menuItems: function () {
                var logout = this.logoutMenuItem;
                if (!this.currentUser.role) {
                    return logout;
                }

                if (this.currentUser.role === "NORMAL") {
                    return this.normalMenuItems.concat(this.accessControlItems).concat(logout);
                }
                if (this.currentUser.role === "POWER") {
                    return this.normalMenuItems.concat(this.powerMenuItems).concat(this.accessControlItems).concat(logout);
                }
                if (this.currentUser.role === "ADMIN") {
                    return this.normalMenuItems.concat(this.powerMenuItems).concat(this.adminMenuItems).concat(this.accessControlItems).concat(logout);
                }
                if (this.currentUser.role === "ACCESS_MANAGER"){
                    return this.normalMenuItems.concat(this.accessControlItems).concat(logout);
                }

                return logout;
            }
        },
        created() {
            var userOverview = Vue.prototype.$currentUser;
            this.selectedWard = Vue.prototype.$currentWard.displayName;
            this.showStatusOverviewMenu = Vue.prototype.$showStatusOverviewMenu;

            if (userOverview) {
                this.currentUser.name = Vue.firstLetterToUppercase(userOverview.displayName);
                this.currentUser.role = userOverview.user.role ? userOverview.user.role : "";
                this.currentUser.wards = userOverview.lwWards;
            } else {
                console.log("No user fetched!!");
                this.currentUser = undefined;
            }
        }
    }

</script>

<style>

</style>

